import { render, staticRenderFns } from "./SplitGiftcard.vue?vue&type=template&id=944f6e60&"
import script from "./SplitGiftcard.vue?vue&type=script&lang=js&"
export * from "./SplitGiftcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports